import React from 'react'
import { Component } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Korrektur: Entferne das überflüssige Komma


import "./style/login.css"
import "./style/dasboart.css"
import "./style/loinport.css"
import "./style/list.css"
import "./style/footer.css"
import "./style/cursor.css"

import Login from './components/login';
import ProtectedRoute from './components/ProtectedRoute';
import Main from './components/main';
import Mainlogin from './components/mainlogin';



function Log() {
  return <Login />;
}
function Das() {
  return <Main />;
}
function Port() {
  return <Mainlogin />;
}
class App extends Component {
    render() {
        return (
            <Router>
              <Routes>
              
              <Route path="/login" element={<Log/>} /> {/* Achte darauf, dass die Route kleingeschrieben ist */}
              <Route path="/" element={<Log/>} /> {/* Achte darauf, dass die Route kleingeschrieben ist */}
              <Route path="/loginbort" element={
                <ProtectedRoute>
                  <Port/>
                </ProtectedRoute>
              } />
              <Route path="/dasboart" element={
                <ProtectedRoute>
                  <Das/>
                </ProtectedRoute>
              } />
              <Route path="/dasboart" element={
                <ProtectedRoute>
                  <Das/>
                </ProtectedRoute>
              } />
            </Routes>

             </Router>
            
        )
    }
}

export default App;

